import { auth } from "./setup";
import type { ActionCodeSettings } from "firebase/auth";
import {
  sendSignInLinkToEmail,
  isSignInWithEmailLink,
  signInWithEmailLink,
} from "firebase/auth";
import {
  CreateMagicLinkFunction,
  ProcessMagicLinkFunction,
} from "src/types/auth";

/**************
 * Magic Link *
 **************/
export const createMagicLink: CreateMagicLinkFunction = (email) => {
  const path = "/dashboard";
  const url = new URL(path, __FRONTEND_BASE_URL__).toString();
  const config: ActionCodeSettings = {
    url,
    handleCodeInApp: true,
  };
  return sendSignInLinkToEmail(auth, email, config);
};

export const processMagicLink: ProcessMagicLinkFunction = (onError) => {
  if (isSignInWithEmailLink(auth, window.location.href)) {
    const email = window.localStorage.getItem("emailForSignIn");
    // The client SDK will parse the code from the link for you.
    signInWithEmailLink(auth, email!, window.location.href)
      .then(() => {
        console.log("MAGIC LINK CONFIRMED");
        window.localStorage.removeItem("emailForSignIn");
        window.location.href = `/finding-user-dealer/dashboard`;
      })
      .catch((error) => {
        console.log("MAGIC LINK CONFIRMATION ERROR:", error);
        if (error.code && error.code === "auth/invalid-action-code") {
          console.log("Expired magic link");
        }
        if (onError) {
          return onError(error);
        }
      });
  }
};
